import { render, staticRenderFns } from "./contractDetail.vue?vue&type=template&id=b58a9eda&scoped=true"
import script from "./contractDetail.vue?vue&type=script&lang=js"
export * from "./contractDetail.vue?vue&type=script&lang=js"
import style0 from "./contractDetail.vue?vue&type=style&index=0&id=b58a9eda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b58a9eda",
  null
  
)

export default component.exports